import { render } from "./GroupsEdit.vue?vue&type=template&id=55281e2a"
import script from "./GroupsEdit.vue?vue&type=script&lang=js"
export * from "./GroupsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__